import DatasetsPrincipalPanel from './datasets-principal-panel'

/**
 * @param {boolean} [options.rollupPermissionSelector=false] indicates that
 * principals should have a select in the update cell to choose the rollup type
 */
const PermissionsByFilterPanelContent = DatasetsPrincipalPanel.extend(/** @lends PermissionsByFilterPanelContent.prototype */{

	//content-container required for Collapsible
	className: '',

	// This view is contained within a principal-panel, so we do not need to
	// setup tooltips again, it's covered by the containing principal-panel.
	_setupTooltips: () => {},

	render: function() {
		DatasetsPrincipalPanel.prototype.render.apply(this, arguments)
		this.$('thead').addClass('is-not-displayed')
		return this
	},

	addPrincipal: function(principal) {
		DatasetsPrincipalPanel.prototype.addPrincipal.apply(this, arguments)
		this.addLinkToPrincipalLabels()
	}
})

export default PermissionsByFilterPanelContent
PermissionsByFilterPanelContent.__filename__ = 'datasets/edit/permissions-by-filter-panel-content.js'
